import { render, staticRenderFns } from "./EditApiUser.vue?vue&type=template&id=22fee240&scoped=true"
import script from "./EditApiUser.vue?vue&type=script&lang=js"
export * from "./EditApiUser.vue?vue&type=script&lang=js"
import style0 from "./EditApiUser.vue?vue&type=style&index=0&id=22fee240&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fee240",
  null
  
)

export default component.exports